import {
  AutoComplete,
  AutoCompleteMulti,
  ISelectType,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { insuranceRegisterList } from "../../../../../../../../services/ticketAutRecRuleTicketDefDoc.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationRecRuleTicketDefDoc.";

export const Insurances = memo(() => {
  const { t } = useTranslation();

  const [
    ticketAutRecRuleTicketDefDocsInsurancesOptions,
    setTicketAutRecRuleTicketDefDocsInsurancesOptions,
  ] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(insuranceRegisterList);

  const fetchTicketAutRecRuleTicketDefDocsInsurances = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      setTicketAutRecRuleTicketDefDocsInsurancesOptions(
        data.map((d) => ({
          id: d.identifier.toString(),
          name: d.insuranceName,
        }))
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchTicketAutRecRuleTicketDefDocsInsurances();
  }, [fetchTicketAutRecRuleTicketDefDocsInsurances]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        fullWidth
        options={ticketAutRecRuleTicketDefDocsInsurancesOptions}
        name="ticketAutRecRuleTicketDefDocsInsurances"
        label={t(translationPath + "ticketAutRecRuleTicketDefDocsInsurances")}
        getOptionLabel={(option) => option.name}
        size="small"
        keepOpenOnSelect={true}
      />
    </Grid>
  );
});
